import { useState } from "react";
import LocationImg from "../../../../assets/images/location.svg";

const PracticeLocations = ({ addresses, name, gender }) => {
  const [currentPage, setCurrentPage] = useState(0);

  // Function to detect if the device is iOS
  const isIOS = () => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  };

  // Function to construct map URL
  const getMapUrl = (address) => {
    const fullAddress = `${address.street_address}, ${address.address_locality}, ${address.address_region}, ${address.postal_code}`;
    const encodedAddress = encodeURIComponent(fullAddress);

    if (isIOS()) {
      // Apple Maps URL
      return `https://maps.apple.com/?address=${encodedAddress}`;
    } else {
      // Google Maps URL
      return `https://www.google.com/maps?q=${encodedAddress}`;
    }
  };

  // Handle click to open map
  const handleClick = (address) => {
    const mapUrl = getMapUrl(address);
    window.open(mapUrl, "_blank"); // Open in new tab
  };

  // Pagination logic
  const itemsPerPage = 3;
  const totalPages = Math.ceil(addresses.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentAddresses = addresses.slice(startIndex, endIndex);

  // Show pagination only if more than 3 items
  const showPagination = addresses.length > 3;

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="container" style={{ background: "#f8f9fb" }}>
      <div className="car shadow-sm p-2" style={{ background: "#F4F5F4" }}>
        <div className="card-body">
          <h2 className="h2 mb-0 fw-semibold">Practice Locations</h2>
          <p className="lead" style={{ fontSize: "1rem" }}>
            {name} practices at the following location(s) to better serve
            patients. You can find the details and directions below.
          </p>

          <div className="row mt-4 justify-content-center">
            {currentAddresses.map((address, index) => (
              <div
                className={`col-lg-4 col-md-6 mb-4`}
                key={startIndex + index}
                onClick={() => handleClick(address)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="p-3 bg-white rounded h-100 mx-auto"
                  style={{ width: "95%", maxWidth: "350px" }}
                >
                  <div
                    className="d-flex align-items-start"
                    style={{
                      fontSize: "0.9rem",
                    }}
                  >
                    <img
                      src={LocationImg}
                      alt="location"
                      className="me-2 mt-1"
                      style={{ width: "16px", height: "16px", flexShrink: 0 }}
                    />
                    <div>
                      {address.street_address},
                      <address style={{ fontSize: "0.9rem" }} className="mb-0">
                        {address.address_locality}, {address.address_region}{" "}
                        {address.postal_code}
                      </address>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Pagination indicator as fourth item */}
            {/* {showPagination &&
              currentAddresses.length === 3 &&
              remainingItems > 0 && (
                <div className="col-md-4 mb-4">
                  <div
                    className="p-3 bg-white rounded h-100 d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "80%",
                      cursor: "pointer",
                      minHeight: "120px",
                    }}
                    onClick={handleNextPage}
                  >
                    <div className="text-center">
                      <div className="mb-2">
                        <svg
                          width="24"
                          height="24"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
                        </svg>
                      </div>
                      <p className="mb-1 fw-semibold">
                        +{remainingItems} more location
                        {remainingItems > 1 ? "s" : ""}
                      </p>
                      <small className="text-muted">Click to view more</small>
                    </div>
                  </div>
                </div>
              )} */}
          </div>

          {/* Pagination dots */}
          {showPagination && (
            <div className="d-flex justify-content-end align-items-end mt-3">
              <button
                className="btn btn-sm me-2 rounded-circle"
                onClick={handlePrevPage}
                disabled={currentPage === 0}
                style={{
                  width: "30px",
                  opacity: currentPage === 0 ? 0.5 : 1,
                  backgroundColor: currentPage !== 0 ? "#0d6efd" : "grey",
                  color: currentPage !== 0 ? "white" : "black",
                  border: "none",
                }}
              >
                ‹
              </button>

              <button
                className="btn btn-sm ms-2 rounded-circle"
                onClick={handleNextPage}
                disabled={currentPage === totalPages - 1}
                style={{
                  width: "30px",
                  opacity: currentPage === totalPages - 1 ? 0.5 : 1,
                  backgroundColor:
                    currentPage !== totalPages - 1 ? "#0d6efd" : "grey",
                  color: currentPage !== totalPages - 1 ? "white" : "black",
                  border: "none",
                }}
              >
                ›
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PracticeLocations;
